import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContractTerminationReasonCreateComponent } from './contract-termination-reason-create/contract-termination-reason-create.component';
import { ContractTerminationReasonDetailsComponent } from './contract-termination-reason-details/contract-termination-reason-details.component';
import { ContractTerminationReasonEditComponent } from './contract-termination-reason-edit/contract-termination-reason-edit.component';
import { ContractTerminationReasonRoutingModule } from './contract-termination-reason-routing.module';

@NgModule({
  declarations: [
    ContractTerminationReasonDetailsComponent,
    ContractTerminationReasonCreateComponent,
    ContractTerminationReasonEditComponent,
  ],
  imports: [CommonModule, SharedModule, ContractTerminationReasonRoutingModule],
})
export class ContractTerminationReasonModule {}
